//@author: devin

import { NgModule } from "@angular/core";
import { S25ItemComponent } from "./s25.item.component";
import { S25ItemUnwrapperComponent } from "./s25.item.unwrapper.component";

// TODO: remove this
@NgModule({
    imports: [S25ItemComponent, S25ItemUnwrapperComponent],
    exports: [S25ItemComponent, S25ItemUnwrapperComponent],
})
export class S25ItemModule {
    constructor() {}
}
